// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2q5pL","list":"PatternAutocomplete_list__80z2K"};